import { ITypedReduxAction } from '../../types/redux';
import { actionGenerator } from '../../utils/redux';

export enum EMlSearchSessionGuidActionTypes {
  Set = 'mlSearchSessionGuid/set',
}

export type TMlSearchSessionGuidSet = ITypedReduxAction<EMlSearchSessionGuidActionTypes.Set, string | null>;

export const setMlSearchSessionGuid = actionGenerator<EMlSearchSessionGuidActionTypes.Set, string | null>(
  EMlSearchSessionGuidActionTypes.Set,
);

export type TMlSearchSessionGuidActions = TMlSearchSessionGuidSet;
